import React from 'react';
import { Users, FileText, Shield, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../auth/AuthContext';
import { getApiUrl } from '../../../utils/apiConfig';
import './styles.css';

export default function AdminDashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [stats, setStats] = React.useState(null);
  const [users, setUsers] = React.useState([]);

  React.useEffect(() => {
    fetch(`${getApiUrl()}/api/dashboard/stats`)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => setStats(data))
      .catch(err => console.error("Stats API error:", err));

    fetch(`${getApiUrl()}/api/users`)
      .then(res => res.json())
      .then(data => setUsers(data.slice(0, 4)))
      .catch(err => console.error("Users API error:", err));
  }, []);

  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
  });

  const KPI_DATA = [
    { label: 'Total Users',   value: stats?.totalUsers || '0',    pct: '+5%',  iconBg: '#ede9fe', iconColor: '#5b21b6', icon: Users      },
    { label: 'Total Reports', value: stats?.totalReports || '0',  pct: '+12%', iconBg: '#dcfce7', iconColor: '#16a34a', icon: FileText   },
    { label: 'Active Roles',  value: '2',      pct: '',     iconBg: '#fff7ed', iconColor: '#ea580c', icon: Shield     },
  ];

  return (
    <div className="ad-page">

      {/* Header */}
      <div className="ad-page-header">
        <div>
          <h2>Welcome back, {user?.name || 'System'}! 🛡️</h2>
          <p>{today}</p>
        </div>
        <button className="ad-export-btn">
          <Download size={15} /> Export Report
        </button>
      </div>

      {/* KPI */}
      <div className="ad-kpi-grid">
        {KPI_DATA.map(k => {
          const Icon = k.icon;
          return (
            <div className="ad-kpi-card" key={k.label}>
              <div className="ad-kpi-top">
                <div className="ad-kpi-icon" style={{ background: k.iconBg }}>
                  <Icon size={18} color={k.iconColor} strokeWidth={1.8} />
                </div>
                {k.pct && <span className="ad-kpi-pct">{k.pct}</span>}
              </div>
              <div className="ad-kpi-value">{k.value}</div>
              <div className="ad-kpi-label">{k.label}</div>
            </div>
          );
        })}
      </div>

      {/* Row 2: Users + Logs */}
      <div className="ad-row2">
        <div className="ad-card">
          <div className="ad-card-header">
            <h3>User Management</h3>
            <button className="ad-link-btn" onClick={() => navigate('/admin/users')}>
              View all →
            </button>
          </div>
          {users.map((u, i) => (
            <div className="ad-user-row" key={i}>
              <div className="ad-user-av" style={{ background: '#ede9fe', color: '#5b21b6' }}>
                {u.firstName?.charAt(0) || u.name?.charAt(0) || 'U'}
              </div>
              <div className="ad-user-info">
                <p>{u.firstName} {u.lastName}</p>
                <span>{u.email}</span>
              </div>
              <span className="ad-badge" style={{ background: '#ede9fe', color: '#5b21b6' }}>
                {u.role}
              </span>
              <span className={`ad-status ${u.status || 'inactive'}`}>{u.status || 'inactive'}</span>
            </div>
          ))}
        </div>

        <div className="ad-card">
          <div className="ad-card-header">
            <h3>Recent Activity</h3>
            <button className="ad-link-btn" onClick={() => navigate('/admin/audit')}>
              View all →
            </button>
          </div>
          {(stats?.recentActivity || []).map((l, i) => (
            <div className="ad-log-row" key={i}>
              <div className="ad-log-dot" style={{ background: '#16a34a' }} />
              <div className="ad-log-info">
                <p>
                  Submitted report for {l.zone}
                  <span className="ad-mod-badge" style={{ background: '#dcfce7', color: '#16a34a' }}>
                    Reporting
                  </span>
                </p>
                <span>{l.user} · {l.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Row 3: Stats */}
      <div className="ad-row3">
        <div className="ad-card">
          <h3>System Health</h3>
          {[
            { label: 'API Uptime',      value: '99.9%',   color: '#16a34a' },
            { label: 'DB Connections',  value: '24 / 100',color: ''        },
            { label: 'Last Backup',     value: '2h ago',  color: ''        },
            { label: 'Pending Jobs',    value: '3',       color: '#ea580c' },
            { label: 'Error Rate',      value: '0.02%',   color: '#16a34a' },
            { label: 'Active Sessions', value: '18',      color: ''        },
          ].map(s => (
            <div className="ad-health-row" key={s.label}>
              <span className="ad-stat-lbl">{s.label}</span>
              <span className="ad-stat-val" style={s.color ? { color: s.color } : {}}>
                {s.value}
              </span>
            </div>
          ))}
        </div>
      </div>



    </div>
  );
}